import React from "react";
import LinkPreviewCard from "./LinkPreviewCard";
import { FaInstagram, FaLinkedin, FaMailBulk, FaMobile } from "react-icons/fa";

const ShowMoreModal = ({ data }) => {
  const linkArr = data?.link.split(",");
  return (
    <div className="more-card-wrapper">
      <div className="d-block">
        <div className="w-100 profile-more-info mb-3">
          {/* <p>{data.about}</p> */}
          <hr />
          <h5>Contact</h5>
          <div className="d-flex align-items-center justify-content-center w-100 pad-10">
            <div className="w-60-px">
              <FaMailBulk />
            </div>
            <div className="more-info-text-content w-90">
              <p className="mb-0">
                <strong>Email address</strong>
              </p>
              <p className="more-info-text"> {data.email}</p>
            </div>
          </div>
          {/* <div className="d-flex align-items-center justify-content-center w-100 pad-10">
            <div className="w-60-px">
              <FaMobile />
            </div>
            <div className="more-info-text-content w-90">
              <p className="mb-0">
                <strong>Phone number</strong>
              </p>
              <p className="more-info-text"> {data.phone}</p>
            </div>
          </div> */}

          {/* <p><FaMobile /> {data.phone}</p>
                <p><a href={newUrl} target="_blank"><strong>Connect with me </strong></a></p>
                <div className="link-card-preview">
                  <LinkPreviewCard url={newUrl} />
                </div> */}
        </div>
        <div>
          {linkArr.length > 0 &&
            linkArr.map((item) => {
              const trimmedUrl = item.trim();
              const newUrl = trimmedUrl.startsWith("https://")
                ? trimmedUrl
                : `https://${trimmedUrl}`;

              // console.log("new", newUrl.split("/"));

              return (
                <div
                  className="d-flex align-items-center justify-content-center w-100 pad-10 profile-more-info"
                  key={item}
                >
                  <div className="w-60-px">
                    {newUrl &&
                    newUrl.split("/")[2] &&
                    newUrl.split("/")[2].includes("instagram") ? (
                      <FaInstagram />
                    ) : (
                      <FaLinkedin />
                    )}
                  </div>
                  <div className="w-90">
                    <p className="mb-0">
                      <strong>
                        Your{" "}
                        {newUrl &&
                        newUrl.split("/")[2] &&
                        newUrl.split("/")[2].includes("instagram")
                          ? "Instagram"
                          : "Linkedin"}{" "}
                        Profile
                      </strong>
                    </p>
                    <a className="more-info-text" href={newUrl} target="_blank">
                      {newUrl}
                    </a>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ShowMoreModal;
